import help_background from '../assets/svg/help_background.svg';
import palette from './palette.js';

const HelpSectionStyles = {
  helpSectionContainer: {
    backgroundImage: `url(${help_background})`,
    minHeight: { lg: '92vh' },
    overflow: 'hidden',
    flexDirection: { xs: 'column', sm: 'row' },
  },
  image: {
    height: '100%',
    width: '100%',
    transform: 'rotate(-1deg)',
    objectFit: 'contain',
    display: { xs: 'none', lg: 'flex' },
    marginTop: { md: '10vh' },
    marginLeft: { md: '10vh' },
    paddingLeft: '6vh',
    marginBottom: '6vh',
    alignContent: { xs: 'right' },
    justifyContent: { xs: 'right' },
  },
  helpBox: {
    maxWidth: { lg: '28vw' },
    width: { xs: '90%', sm: '60%', md: '90%', lg: '80%' },
    color: palette.white,
    backgroundColor: 'rgba(21, 30, 36, 0.8);',
    textAlign: 'left',
    fontFamily: 'Arial',
    marginTop: { xs: '6vh', sm: '2vh', md: '1vh' },
    margin: 'auto',
    marginLeft: { lg: '0vh' },
    marginBottom: '2vh',
    padding: '7%',
  },
  helpTitle: {
    fontWeight: 'bold',
    typography: 'h5',
    fontSize: { xs: '25px', md: '30px' },
    paddingBottom: { xs: '3vh', md: '3vh' },
  },
  mobileImage: {
    height: '100%',
    width: { xs: '115%', sm: '76%', md: '64%' },
    margin: 'auto',
    marginLeft: { xs: '-8vw', sm: 'auto' },
    alignContent: 'center',
    transform: 'rotate(-1deg)',
    objectFit: 'contain',
    display: { xs: 'flex', lg: 'none' },
    marginTop: { xs: 'calc(-12%)', md: 'calc(-8%)' },
    marginBottom: { xs: 'calc(15%)', sm: 'calc(5%)' },
    overflow: 'hidden',
  },
  helpContentBox: {
    paddingBottom: { xs: '5vh', sm: '3vh' },
  },
  helpcontent: {
    typography: { xs: 'body2', sm: 'body1' },
  },
  link: {
    color: palette.gt_green_6,
    textDecoration: 'underline',
  },
};
export default HelpSectionStyles;
